import BaseStore from "@/v1/utils/BaseStore";

const initialState = {};
const store = new BaseStore("invoicingReport", initialState);

const reducer = {};

export default store.reducer(reducer);
